/* src/app/home-new/tooltip-info-components/tooltip-info-page-orientation/tooltip-info-page-orientation.component.scss */
img {
  min-width: 70px;
  max-height: 70px;
  margin: auto;
}
/*# sourceMappingURL=tooltip-info-page-orientation.component-E2JFENK3.css.map */
